import { Container } from 'react-bootstrap';
import { CircleFill } from 'react-bootstrap-icons';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import './Roadmap3.css';

const RoadMap3 = () => {
  return (
    <Container fluid className='rd__cover'>
      <h1 className='roadmap3__h1'> ROADMAP</h1>
      <Container fluid className='rd__main'>
        <VerticalTimeline>
          <VerticalTimelineElement
            contentStyle={{
              background: '#9dffb3',
              color: '#5d2f6b',
              borderRadius: '20px',
              textAlign: 'left',
            }}
            contentArrowStyle={{ borderRight: '10px solid  #9dffb3' }}
            className='vertical-timeline-element--work'
            date='PHASE 1'
            // iconStyle={{ background: 'rgb(255, 183, 0)', color: '#000' }}
            // icon={<CircleFill className='ml-4' />}
          >
            <div>
              <div className='phase__mobi'> PHASE 1</div>
              <span className='roadmap3__bullet'>
                {' '}
                Minting of the collection in our website, fair prize of 0.05Eth.
                The mint of 10000 nft is divided into three parts of 3333 each.
              </span>
              <span className='roadmap3__bullet'>
                {' '}
                Launch of the project on opensea{' '}
              </span>

              <span className='roadmap3__bullet'>
                {' '}
                Launch of our ecological t-shirt, composed only by recycled
                material{' '}
              </span>
            </div>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            contentStyle={{
              background: '#9dffb3',
              color: '#5d2f6b',
              borderRadius: '20px',
              textAlign: 'left',
            }}
            contentArrowStyle={{ borderRight: '10px solid  #9dffb3' }}
            className='vertical-timeline-element--work'
            date='PHASE 2'
            // iconStyle={{ background: 'rgb(255, 183, 0)', color: '#000' }}
            icon={<CircleFill className='ml-4' />}
          >
            <div>
              <div className='phase__mobi'> PHASE 2</div>
              <span className='roadmap3__bullet'>
                Launch of a 3D cats collection
              </span>
              <span className='roadmap3__bullet'>
                Release of a DAO for the NFT's owners
              </span>
              <span className='roadmap3__bullet'>
                The utilities of this collection will be the same as in the
                first phase, and the monetary award for the contents will
                significantly rise.
              </span>
              <span className='roadmap3__bullet'>
                More travel donations for our holders to discover the beauty of
                this world
              </span>
            </div>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            contentStyle={{
              background: '#9dffb3',
              color: '#5d2f6b',
              borderRadius: '20px',
              textAlign: 'left',
            }}
            contentArrowStyle={{ borderRight: '10px solid  #9dffb3' }}
            className='vertical-timeline-element--work'
            date='PHASE 3'
            // iconStyle={{ background: 'rgb(255, 183, 0)', color: '#000' }}
            icon={<CircleFill className='ml-4' />}
          >
            <div>
              <div className='phase__mobi'> PHASE 3</div>

              <span className='roadmap3__bullet'>
                Our mission may now begin! We'll start traveling around the
                globe to show you the natural beauty of our planet via our
                YouTube channel. On each trip, we'll plant many trees and do
                other helpful things for the environment.{' '}
              </span>
              <span className='roadmap3__bullet'>
                Additionally, you can travel independently across the globe
                using our services—we will, of course, cover all costs! We wish
                to demonstrate to you how beautiful this planet is! With your
                help, we will begin collecting plastic from all around the
                world. We will give all the plastic a new life through projects
                you will learn about in the future. Keep in mind that by working
                together, we can rescue the globe, but the success of our
                initiative, "THE BEAUTY WILL SAVE THE WORLD," depends on your
                support.
              </span>
              <span className='roadmap3__bullet'>
                The launch of a YouTube trip channel where we will demonstrate
                the wonders of this planet and explain why we must preserve it.
                50% of the revenue from the YouTube channel will go to charity
                to protect our seas, and 50% will be given to nft holders.
              </span>
            </div>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            contentStyle={{
              background: '#9dffb3',
              color: '#5d2f6b',
              borderRadius: '20px',
              textAlign: 'left',
            }}
            contentArrowStyle={{ borderRight: '10px solid  #9dffb3' }}
            className='vertical-timeline-element--work'
            date='PHASE 4'
            // iconStyle={{ background: 'rgb(255, 183, 0)', color: '#000' }}
            icon={<CircleFill className='ml-4' />}
          >
            <div>
              <div className='phase__mobi'> PHASE 4</div>

              <span className='roadmap3__bullet'>
                Opening an e-commerce store to sell items made using innovative
                bioplastics or environmentally sustainable products.
              </span>
              <span className='roadmap3__bullet'>
                20% of the revenues from these outlets will be returned to NFT
                holders every month, generating a 100% passive income.
              </span>
            </div>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            contentStyle={{
              background: '#9dffb3',
              color: '#5d2f6b',
              borderRadius: '20px',
              textAlign: 'left',
            }}
            contentArrowStyle={{ borderRight: '10px solid  #9dffb3' }}
            className='vertical-timeline-element--work'
            date='PHASE 5'
            // iconStyle={{ background: 'rgb(255, 183, 0)', color: '#000' }}
            icon={<CircleFill className='ml-4' />}
          >
            <div>
              <div className='phase__mobi'> PHASE 5 </div>

              <span className='roadmap3__bullet'>
                Funding for initiatives involving exceptional materials and
                novelties for environmental protection (similar to a startup
                incubator). Nft holders will receive 20% of investment revenue.
              </span>
              <span className='roadmap3__bullet'>
                Projects include (for the time being): Kanesis, which produces
                novel bioplastics from hemp and other agricultural waste; more
                info on their website.
              </span>
              <span className='roadmap3__bullet'>
                Worldwide wind, which deals with the production of renewable
                energy; more info on their website
              </span>
              <p class='contact__p1'>
                Note: These are not collaborations but only examples of project
                that have a strong environmental ethic
              </p>
            </div>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            contentStyle={{
              background: '#9dffb3',
              color: '#5d2f6b',
              borderRadius: '20px',
              textAlign: 'left',
            }}
            contentArrowStyle={{ borderRight: '10px solid  #9dffb3' }}
            className='vertical-timeline-element--work'
            date='PHASE 6'
            // iconStyle={{ background: 'rgb(255, 183, 0)', color: '#000' }}
            icon={<CircleFill className='ml-4' />}
          >
            <div>
              <div className='phase__mobi'> PHASE 6 </div>

              <span className='roadmap3__bullet'>
                You are mistaken if you believe the project is finished here. We
                have huge ideas for the future, and we believe that by working
                together, we will be able to rescue the planet.
              </span>
            </div>
          </VerticalTimelineElement>
        </VerticalTimeline>
        <div>
          <p className='bottom__p__box'>
            Last but not least, if you own a Kutee Kitty, you may claim to be a
            genuine cat and environment lover! And a real humanitarian, working
            to protect and beautify the world!
          </p>
        </div>
      </Container>
    </Container>
  );
};

export default RoadMap3;
